import classNames from 'classnames'
import { useMemo } from 'react'
import { MdArrowForward, MdOpenInNew } from 'react-icons/md'

import type { MouseEvent, ReactElement } from 'react'

import './styles.scss'

export interface Props {
  backgroundColor?: 'light' | 'dark'
  className?: string
  label: string
  onClick: (evt: MouseEvent<HTMLDivElement>) => void
  size?: Exclude<SIZES, 'large'>
  type?: 'external' | 'internal' | 'default'
}

const LinkButton = ({
  backgroundColor = 'dark',
  className,
  label,
  onClick,
  size = 'medium',
  type = 'default',
}: Props): ReactElement => {
  /** Local state */

  const linkButtonClasses = classNames('link-button-component__label', size, {
    'background-light': backgroundColor === 'light',
  })

  const iconClasses = classNames('link-icon', {
    'background-light': backgroundColor === 'light',
  })

  const iconType = useMemo(() => {
    switch (type) {
      case 'default':
        return ''
      case 'external':
        return <MdOpenInNew className={iconClasses} size={size === 'medium' ? 14 : 13} />
      case 'internal':
        return <MdArrowForward className={iconClasses} size={size === 'medium' ? 14 : 13} />
    }
  }, [iconClasses, size, type])

  /** Render */

  return (
    <div className={classNames('link-button-component', className)} onClick={onClick}>
      <label className={linkButtonClasses}>{label}</label>
      {iconType}
    </div>
  )
}

export default LinkButton
